module.exports = __webpack_public_path__ + "img/bg-text-threesquirrels.e603eee3.png";